import { ShieldAlert } from 'lucide-react';

import { deriveGuardianship, legalCapacityLabel } from '../persons/persons-adapter';

import type { PersonDetail } from '../persons/types';

/**
 * ColetaLegalAdvisory — D4. Em vez do "bloqueio por guardianship" do mockup (que
 * o finalize do v1 NÃO impõe — netComet é professional), exibimos um AVISO
 * read-only honesto derivado de `getPerson()` (reuso `deriveGuardianship`/
 * `legalCapacityLabel` da Tela 2). NÃO bloqueia o finalize.
 *
 * Só renderiza algo quando há sinal real (guardianship ativa/pendente/vencida OU
 * capacidade jurídica != plena). Sem sinal → null (nada inventado).
 */
export function ColetaLegalAdvisory({ person }: { person: PersonDetail }): JSX.Element | null {
  const guardianship = deriveGuardianship(person.guardianshipsAsWard);
  const capacity = person.legalCapacity;
  const capacityRelevant = capacity !== null && capacity.status !== 'full';

  if (guardianship.state === 'none' && !capacityRelevant) return null;

  return (
    <div className="coleta-section">
      <span className="coleta-section__label">Capacidade jurídica</span>
      <div className="coleta-advisory" role="note">
        <ShieldAlert size={14} style={{ flexShrink: 0, marginTop: 2 }} />
        <div>
          {guardianship.state !== 'none' && (
            <div>
              Guardianship registrado: <strong>{guardianship.label}</strong>.
            </div>
          )}
          {capacityRelevant && capacity !== null && (
            <div>
              Capacidade jurídica: <strong>{legalCapacityLabel(capacity)}</strong>.
            </div>
          )}
          <div style={{ marginTop: 4, opacity: 0.85 }}>
            Aviso para conferência — confirme a representação antes de prosseguir. A coleta gera uma
            pendência de revisão humana.
          </div>
        </div>
      </div>
    </div>
  );
}
